"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENTS = exports.GRID_PARAM_KEY = exports.PARAM_KEY = exports.ADDON_ID = void 0;
var ADDON_ID = 'storybook/background';
exports.ADDON_ID = ADDON_ID;
var PARAM_KEY = 'backgrounds';
exports.PARAM_KEY = PARAM_KEY;
var GRID_PARAM_KEY = 'grid';
exports.GRID_PARAM_KEY = GRID_PARAM_KEY;
var EVENTS = {
  UPDATE: "".concat(ADDON_ID, "/update")
};
exports.EVENTS = EVENTS;